<template>
  <v-menu
    v-model="navigation.CRMWhatsappConversationContextMenuIsVisible"
    @update:model-value="navigation.CRMWhatsappConversationContextMenuIsVisible == false ? navigation.CRMWhatsappConversationContextMenuItem = null : null"
    @contextmenu.prevent="navigation.CRMWhatsappConversationContextMenuIsVisible = false; navigation.CRMWhatsappConversationContextMenuItem = null;"
    :scrim="true"
    :activator="false"
    :close-on-content-click="false"
    location-strategy="static"
    style="user-select: none; cursor: default;"
  >
    <v-list 
      density="compact"
      style="position: absolute; width: 400px; height: 180px; max-height: 250px; overflow-y: auto; overflow-x: hidden;" 
      :style="`top: ${navigation.CRMWhatsappConversationContextMenuY}px; left: ${navigation.CRMWhatsappConversationContextMenuX}px;`"
    >
      <v-list-item 
        @click="$generalFunctions.default.copyToClipboard(this, 'ID de la conversación', 'o', navigation.CRMWhatsappConversationContextMenuItem.CRMWhatsappConversationID); navigation.CRMWhatsappConversationContextMenuIsVisible = false; navigation.CRMWhatsappConversationContextMenuItem = null;" 
        title="Copiar ID de la conversación" 
        class="hoverableText" 
      >
        <template v-slot:prepend>
          <v-icon color="indigo">mdi-barcode</v-icon>
          <v-icon color="indigo" size="x-small">mdi-paperclip</v-icon>
        </template>
      </v-list-item>
      <v-list-item 
        @click="copyCRMWhatsappConversationToClipboard(); navigation.CRMWhatsappConversationContextMenuIsVisible = false; navigation.CRMWhatsappConversationContextMenuItem = null;" 
        title="Copiar resumen de la conversación" 
        class="hoverableText" 
      >
        <template v-slot:prepend>
          <v-icon color="indigo">mdi-chat</v-icon>
          <v-icon color="indigo" size="x-small">mdi-paperclip</v-icon>
        </template>
      </v-list-item>
      <v-list-item 
        @click="$root.dialogComponent.openCRMWhatsappConversationDialog(navigation.CRMWhatsappConversationContextMenuItem.CRMWhatsappConversationID); navigation.CRMWhatsappConversationContextMenuIsVisible = false; navigation.CRMWhatsappConversationContextMenuItem = null;" 
        title="Abrir conversación" 
        class="hoverableText" 
      >
        <template v-slot:prepend>
          <v-icon color="indigo">mdi-chat</v-icon>
        </template>
      </v-list-item>
      <v-list-item 
        @click="$root.dialogComponent.openResumeCRMWhatsappConversationDialog(navigation.CRMWhatsappConversationContextMenuItem.CRMWhatsappConversationID); navigation.CRMWhatsappConversationContextMenuIsVisible = false; navigation.CRMWhatsappConversationContextMenuItem = null;" 
        title="Retomar conversación" 
        class="hoverableText" 
      >
        <template v-slot:prepend>
          <v-icon color="indigo">mdi-chat-plus</v-icon>
        </template>
      </v-list-item>
    </v-list>
  </v-menu>
  
  <div class="mainContainer" @contextmenu.prevent="null" style="user-select: none; cursor: default;">
    <v-card v-if="navigation.searchVisible" :border="$vuetify.display.sm || $vuetify.display.xs ? null : 'e'" elevation="0" rounded="0" color="border" class="navigationContainer"> 
      <v-card elevation="0" rounded="0" color="primary" style="width: 100%; padding: 15px; display: flex; align-items: center;">
        <v-icon size="large" color="indigo">mdi-chat</v-icon>
        <v-icon color="indigo" style="margin-right: 10px;">mdi-view-list</v-icon>
        <h4>LISTA DE CONVERSACIONES</h4>
        <div style="margin-left: auto; display: flex; gap: 5px;">
          <v-icon 
            @click="selectCRMWhatsappConversationFromCRMWhatsappConversationsView(true)" 
            :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsView" 
            size="x-small" 
            class="hoverableElement"
          >
            mdi-magnify
          </v-icon>
          <v-icon 
            @click="setDefaultValues()" 
            :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsView" 
            size="x-small" 
            class="hoverableElement"
          >
            mdi-backspace
          </v-icon>
          <v-icon 
            @click="$generalFunctions.default.copyToClipboard(this, 'Búsqueda de conversaciones', 'a', null)" 
            :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsView" 
            size="x-small" 
            class="hoverableElement"
          >
            mdi-share-variant
          </v-icon>
          <template v-if="navigation.searchVisible == true && display.CRMWhatsappConversation.length > 0">
            <v-icon 
              @click="navigation.searchVisible = false" 
              :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsView" 
              size="x-small" 
              class="hoverableElement hideSearchContainer"
            >
              mdi-arrow-left-bottom-bold
            </v-icon>
          </template>
        </div>
      </v-card> 
      <v-card elevation="0" rounded="0" color="indigo" style="width: 100%; height: 2px;"></v-card>
      <div class="navigationSearchContainer">
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top" style="margin-bottom: 10px;">
          <template v-slot:activator="{ props }">
            <v-text-field 
              v-bind="props"
              ref="CRMWhatsappConversationID"
              v-model="input.CRMWhatsappConversationID"
              @update:model-value="updateURLSearchQuery()"
              @keydown.enter.prevent="selectCRMWhatsappConversationFromCRMWhatsappConversationsView(true)"
              @keypress="$generalFunctions.default.allowOnlyNumberOnInput($event)"
              :loading="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsView"
              :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsView"
              prepend-inner-icon="mdi-barcode"
              type="number"
              label="Buscar por identificador interno"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              clearable
              hide-details
              hide-spin-buttons
              style="margin-bottom: 15px;"
            ></v-text-field>
          </template>
          <span style="max-width: 400px; display: block;">El identificador interno es el consecutivo único que se asigna de forma automática a la conversación. Si se coloca un identificador interno, se buscará la única conversación que coincida con el mismo, ignorando el resto de filtros seleccionados</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top" style="margin-bottom: 10px;">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="CRMWhatsappContactID"
              v-model="input.CRMWhatsappContactID"
              v-model:search="input.CRMWhatsappContactSearch"
              @update:model-value="updateURLSearchQuery()"
              @input="autocompleteCRMWhatsappContact()"
              @keydown.enter.prevent="selectCRMWhatsappConversationFromCRMWhatsappConversationsView(true)"
              :loading="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsView || loader.autocompleteCRMWhatsappContact"
              :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsView"
              :items="display.CRMWhatsappContactOptions"
              prepend-inner-icon="mdi-account"
              item-value="CRMWhatsappContactID"
              item-title="CRMWhatsappContactAutocomplete"
              label="Filtrar por contacto"
              placeholder="Todos los contactos"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              clearable
              hide-no-data
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.CRMWhatsappContactID == item.raw.CRMWhatsappContactID"
                    class="hoverableText"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.CRMWhatsappContactID == item.raw.CRMWhatsappContactID"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <div>
                      <p>{{ item.raw.CRMWhatsappContactName }}</p>
                      <p style="font-size: small; color: #9e9e9e;">{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(item.raw.CRMWhatsappContactPhoneNumber, false) }}</p>
                    </div>
                  </v-list-item>
                </v-list>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">El contacto asignado a la conversación. Si se selecciona un contacto, se buscaran todas las conversaciones que tengan asignado al contacto seleccionado</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="CRMAgentID"
              v-model="input.CRMAgentID"
              v-model:search="input.CRMAgentIDSearch"
              @update:model-value="input.allCRMAgentIDSelected = input.CRMAgentID.length == systemInformationData.CRMAgents.length; updateURLSearchQuery();"
              @keydown.enter.prevent="selectCRMWhatsappConversationFromCRMWhatsappConversationsView(true)"
              :items="systemInformationData.CRMAgents"
              :loading="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsView"
              :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsView"
              prepend-inner-icon="mdi-briefcase-account"
              item-title="CRMAgentName"
              item-value="CRMAgentID"
              label="Filtrar por agente involucrado"
              placeholder="Todos los agentes involucrados"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              clearable
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allCRMAgentIDSelected" 
                  @update:model-value="input.CRMAgentID = input.allCRMAgentIDSelected ? systemInformationData.CRMAgents.map(CRMAgent => CRMAgent.CRMAgentID) : []; updateURLSearchQuery()"
                  density="compact" 
                  hide-details
                  class="hoverableElement"
                ></v-checkbox-btn>
              </template>
              <template v-slot:chip="{ item, index }">
                <template v-if="index < 3">
                  <v-chip :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.value) ? systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.value).CRMAgentColor : 'primary'" variant="flat" elevation="2" label>
                    <div style="display: flex; align-items: center;">
                      <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.value) ? systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.value).CRMAgentProfilePictureURL : require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                      <p>{{ item.title }}</p>
                    </div>
                    <template v-slot:close>
                      <v-icon 
                        size="smaller"
                        class="hoverableElement"
                        @click.stop="input.CRMAgentID = input.CRMAgentID.filter(CRMAgentID => CRMAgentID != item.value); input.allCRMAgentIDSelected = false; updateURLSearchQuery();"
                      >
                        mdi-close-circle
                      </v-icon>
                    </template>
                  </v-chip>
                </template>
                <template v-if="index == 3">
                  <p style="color: #9e9e9e; font-size: small;">(+{{ input.CRMAgentID.length - 3 }} agente{{ input.CRMAgentID.length - 3 == 1 ? '' : 's' }})</p>                  
                </template>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.CRMAgentID.includes(item.value)"
                    class="hoverableText"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.CRMAgentID.includes(item.value)" 
                        density="compact" 
                        hide-details 
                        readonly
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <template v-if="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.value)">
                      <v-chip :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.value).CRMAgentColor" variant="flat" elevation="2" label style="margin-top: 5px; margin-bottom: 5px;">
                        <div style="display: flex; align-items: center;">
                          <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.value).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;"/>
                          <p>{{ item.title }}</p>
                        </div>
                      </v-chip>
                    </template>
                    <template v-else>
                      <v-chip color="primary" variant="flat" elevation="2" label style="margin-top: 5px; margin-bottom: 5px;">
                        <div style="display: flex; align-items: center;">
                          <img :src="require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;"/>
                          <p>No registrado</p>
                        </div>
                      </v-chip>
                    </template>
                  </v-list-item>
                </v-list>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">El agente de involucrado en la conversación. Si se coloca al menos un agente de involucrado, se buscarán todas las conversaciones en las que haya participado el o los agentes de involucrado seleccionados. Al presionar el ícono de la derecha se seleccionan todos los agentes involucrados disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-date-input
              v-bind="props"
              ref="CRMWhatsappConversationStartDatetime"
              v-model="input.CRMWhatsappConversationStartDatetime"
              @update:model-value="updateURLSearchQuery()"
              @keydown.enter.prevent="selectCRMWhatsappConversationFromCRMWhatsappConversationsView(true)"
              :loading="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsView"
              :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsView"
              prepend-inner-icon="mdi-calendar-start"
              prepend-icon=""
              label="Filtrar por fecha de inicio"
              variant="outlined"
              density="compact"
              multiple="range"
              autocomplete="off"
              hide-details
              style="margin-bottom: 15px;"
            ></v-date-input>
          </template>
          <span style="max-width: 400px; display: block;">El filtro por fecha de inicio de la conversación permite buscar todas las conversaciones que hayan iniciado en una fecha específica</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-date-input
              v-bind="props"
              ref="CRMWhatsappConversationEndDatetime"
              v-model="input.CRMWhatsappConversationEndDatetime"
              @update:model-value="updateURLSearchQuery()"
              @keydown.enter.prevent="selectCRMWhatsappConversationFromCRMWhatsappConversationsView(true)"
              :loading="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsView"
              :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsView"
              prepend-icon=""
              prepend-inner-icon="mdi-calendar-start"
              label="Filtrar por fecha de finalización"
              variant="outlined"
              density="compact"
              multiple="range"
              autocomplete="off"
              hide-details
              style="margin-bottom: 15px;"
            ></v-date-input>
          </template>
          <span style="max-width: 400px; display: block;">El filtro por fecha de finalización de la conversación permite buscar todas las conversaciones que hayan finalizado en una fecha específica</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top" style="margin-bottom: 10px;">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="CRMWhatsappConversationResult"
              v-model="input.CRMWhatsappConversationResult"
              v-model:search="input.CRMWhatsappConversationResultSearch"
              @update:model-value="input.allCRMWhatsappConversationResultSelected = input.CRMWhatsappConversationResult.length == display.CRMWhatsappConversationResultOptions.length; updateURLSearchQuery();"
              @keydown.enter.prevent="selectCRMWhatsappConversationFromCRMWhatsappConversationsView(true)"
              :items="display.CRMWhatsappConversationResultOptions"
              :loading="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsView"
              :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsView"
              prepend-inner-icon="mdi-timeline"
              label="Filtrar por resultado"
              placeholder="Todos los resultados"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              clearable
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allCRMWhatsappConversationResultSelected" 
                  @update:model-value="input.CRMWhatsappConversationResult = input.allCRMWhatsappConversationResultSelected ? display.CRMWhatsappConversationResultOptions : []; updateURLSearchQuery()"
                  density="compact" 
                  hide-details
                  class="hoverableElement"
                ></v-checkbox-btn>
              </template>
              <template v-slot:chip="{ item, index }">
                <template v-if="index < 3">
                  <v-chip color="primary" variant="flat" elevation="2" label>
                    {{ item.title }}
                    <template v-slot:close>
                      <v-icon
                        @click.stop="input.CRMWhatsappConversationResult = input.CRMWhatsappConversationResult.filter(CRMWhatsappConversationResult => CRMWhatsappConversationResult != item.value); input.allCRMWhatsappConversationResultSelected = false; updateURLSearchQuery();"
                        size="smaller"
                        class="hoverableElement"
                      >
                        mdi-close-circle
                      </v-icon>
                    </template>
                  </v-chip>
                </template>
                <template v-if="index == 3">
                  <p style="color: #9e9e9e; font-size: small;">(+{{ input.CRMWhatsappConversationResult.length - 3 }} resultado{{ input.CRMWhatsappConversationResult.length - 3 == 1 ? '' : 's' }})</p>
                </template>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.CRMWhatsappConversationResult.includes(item.value)"
                    class="hoverableText"
                    style="padding-top: 2px; padding-bottom: 2px;"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.CRMWhatsappConversationResult.includes(item.value)" 
                        density="compact" 
                        hide-details 
                        readonly
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <p>{{ item.title }}</p>
                  </v-list-item>
                </v-list>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">El resultado de la conversación indica cómo finalizó la conversación. Si se coloca al menos un resultado, se buscarán todas las conversaciones cuyo resultado coincida con el o los resultados seleccionados. Al presionar el ícono de la izquierda se limpiará el o los resultados seleccionados</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top" style="margin-bottom: 10px;">
          <template v-slot:activator="{ props }">
            <v-textarea
              v-bind="props"
              ref="CRMWhatsappConversationNoteContentOrCRMWhatsappMessageNoteContent"
              v-model="input.CRMWhatsappConversationNoteContentOrCRMWhatsappMessageNoteContent"
              @update:model-value="updateURLSearchQuery()"
              @keydown.enter.prevent="selectCRMWhatsappConversationFromCRMWhatsappConversationsView(true)"
              :loading="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsView"
              :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsView"
              prepend-inner-icon="mdi-note"
              label="Filtrar por nota de la conversación o nota del mensaje"
              placeholder="Todas las notas de la conversación o nota del mensaje"
              variant="outlined"
              rows="2"
              max-rows="4"
              autocomplete="off"
              density="compact"
              clearable
              hide-details
              auto-grow
              style="margin-bottom: 15px;"
            ></v-textarea>
          </template>
          <span style="max-width: 400px; display: block;">La nota de la conversación o nota del mensaje. Si se coloca una nota, se buscarán todas las conversaciones que contengan una nota o un mensaje con una nota que coincida con la nota colocada</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top" style="margin-bottom: 10px;">
          <template v-slot:activator="{ props }">
            <v-textarea
              v-bind="props"
              ref="CRMWhatsappMessageContent"
              v-model="input.CRMWhatsappMessageContent"
              @update:model-value="updateURLSearchQuery()"
              @keydown.enter.prevent="selectCRMWhatsappConversationFromCRMWhatsappConversationsView(true)"
              :loading="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsView"
              :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsView"
              prepend-inner-icon="mdi-comment-text"
              label="Filtrar por contenido del mensaje"
              placeholder="Todos los contenidos del mensaje"
              variant="outlined"
              rows="2"
              max-rows="4"
              autocomplete="off"
              density="compact"
              clearable
              hide-details
              auto-grow
              style="margin-bottom: 15px;"
            ></v-textarea>    
          </template>
          <span style="max-width: 400px; display: block;">El contenido de un mensaje que forma parte de la conversación. Si se coloca un contenido del mensaje, se buscarán todas las conversaciones que contengan un mensaje con un contenido que coincida total o parcialmente con el contenido del mensaje colocado</span>
        </v-tooltip>
      </div>
      <v-card elevation="0" rounded="0" color="indigo" style="width: 100%; height: 2px;"></v-card>
      <v-card color="primary" elevation="0" rounded="0" style="width: 100%; height: 120px; padding: 15px; overflow: hidden; align-items: center; justify-content: center;">
        <v-btn 
          @click="selectCRMWhatsappConversationFromCRMWhatsappConversationsView(true)"
          :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsView" 
          block
          color="indigo"
          class="hoverableText"
        >
        <v-icon size="large" style="margin-right: 10px;">mdi-magnify</v-icon>
        <h3>BUSCAR</h3>
        </v-btn>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="1000" location="top">
          <template v-slot:activator="{ props }">
            <v-btn 
              v-bind="props" 
              @click="setDefaultValues()"
              :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsView" 
              block
              color="secondary"
              style="margin-top: 15px;"
              class="hoverableText"
            >
              <v-icon size="large" style="margin-right: 10px;">mdi-backspace</v-icon>
              <h3>LIMPIAR</h3>
            </v-btn>
          </template>
          <span style="width: 400px; display: block;">Al presionar este botón, se limpiarán los resultados de la búsqueda actual, y se reestablecerán todos los filtros de búsqueda a sus valores por defecto</span>
        </v-tooltip>
      </v-card>
    </v-card>
    <div class="contentContainer">
      <template v-if="loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsView">
        <v-card color="primary" elevation="0" rounded="0" style="width: 100%; height: 55px"></v-card>
        <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
        <div style="flex: 1;">
          <AppLoaderScreen
            :key="Math.random() * 1000000"
            :appLogoSize="'x-small'"
            :loadingText="'Cargando lista de conversaciones'"
            :dotsToAnimate="3"
            :hints="$assets.default.hints.CRMWhatsappConversationsView"
            style="width: 100%; height: 100%;"
          ></AppLoaderScreen>
        </div>
      </template>
      <template v-else>
        <template v-if="display.CRMWhatsappConversation.length > 0">
          <v-data-table
            ref="CRMWhatsappConversationTable"
            :headers="display.CRMWhatsappConversationHeaders.sort((a, b) => a.index - b.index)" 
            :items="display.CRMWhatsappConversation" 
            :loading="loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsView"
            :items-per-page="-1"
            fixed-header
            hover
            style="flex: 1; overflow-y: auto; scrollbar-width: thin;"
          >
            <template v-slot:headers="{ columns }">
              <tr>
                <th v-for="column in columns" :key="column.key">
                  <v-card color="primary" elevation="0" rounded="0" style="display: flex; align-items: center; white-space: nowrap; height: 100%; width: 100%; padding: 0px 25px;">
                    <v-icon v-if="navigation.searchVisible == false && display.CRMWhatsappConversationHeaders.find(header => header.value == column.key).index == 0" @click="navigation.searchVisible = true" size="large" style="margin-right: 10px;">mdi-arrow-right-bottom-bold</v-icon>
                    <v-icon v-if="display.CRMWhatsappConversationHeaders.find(header => header.value == column.key).index > 0" @click="updateTableHeaderIndex(column.key, -1)" color="secondary" size="x-small" class="hoverableElement" style="margin-right: 10px">mdi-arrow-left-bold</v-icon>
                    <v-icon color="indigo" style="margin-right: 5px;">{{ display.CRMWhatsappConversationHeaders.find(header => header.value == column.key).icon }}</v-icon>
                    <span v-if="navigation.tableVisibility[column.key]" style="margin-right: 5px; display: flex; align-items: center;"><strong>{{ display.CRMWhatsappConversationHeaders.find(header => header.value == column.key).title }}</strong></span>
                    <v-icon @click="navigation.tableVisibility[column.key] = !navigation.tableVisibility[column.key]; updateTableVisibility()" color="secondary" size="x-small" class="hoverableElement">mdi-{{ navigation.tableVisibility[column.key] ? 'eye' : 'eye-off' }}</v-icon>
                    <v-icon v-if="display.CRMWhatsappConversationHeaders.find(header => header.value == column.key).index < display.CRMWhatsappConversationHeaders.length - 1" @click="updateTableHeaderIndex(column.key, 1)" color="secondary" size="x-small" class="hoverableElement" style="margin-left: 10px">mdi-arrow-right-bold</v-icon>
                  </v-card>
                  <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
                </th>
              </tr>
            </template>
            <template v-slot:item="row">
              <tr 
                :class="navigation.CRMWhatsappConversationContextMenuItem?.CRMWhatsappConversationID == row.item.CRMWhatsappConversationID ? 'selectedVDataTableRow' : (loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsViewPagination ? 'loadingVDataTableRow' : null)" 
                :style="loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsViewPagination ? 'pointer-events: none;' : null"
              >
                <template v-for="header in display.CRMWhatsappConversationHeaders.sort((a, b) => a.index - b.index)" :key="header.value">
                  <td @contextmenu.prevent="navigation.CRMWhatsappConversationContextMenuIsVisible = true; navigation.CRMWhatsappConversationContextMenuItem = row.item; navigation.CRMWhatsappConversationContextMenuX = $event.clientX; navigation.CRMWhatsappConversationContextMenuY = $event.clientY;">
                    <template v-if="header.value == 'CRMWhatsappConversationID' && navigation.tableVisibility[header.value]">
                      <v-hover>
                        <template v-slot="{ isHovering, props: hoverProps }">
                          <template v-if="isHovering == true && !systemInformationData.tooltipDisabled">
                            <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Copiar ID al portapapeles" location="top">
                              <template v-slot:activator="{ props: tooltipProps }">
                                <p v-bind="tooltipProps" @click="$generalFunctions.default.copyToClipboard(this, `ID de la conversación`, 'o', row.item.CRMWhatsappConversationID)" class="hoverableText" style="color: #3F51B5;"><strong>{{ row.item.CRMWhatsappConversationID }}</strong></p>
                              </template>
                            </v-tooltip>
                          </template>
                          <template v-else>
                            <p v-bind="hoverProps" @click="$generalFunctions.default.copyToClipboard(this, `ID de la conversación`, 'o', row.item.CRMWhatsappConversationID)" class="hoverableText" style="color: #3F51B5;"><strong>{{ row.item.CRMWhatsappConversationID }}</strong></p>
                          </template>
                        </template>
                      </v-hover>
                    </template>
                    <template v-else-if="header.value == 'CRMWhatsappContactID' && navigation.tableVisibility[header.value]">
                      <div style="white-space: nowrap;">
                        <p>{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(row.item) }}</p>
                        <p style="font-size: small; color: #9e9e9e;">{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(row.item.CRMWhatsappConversationPhoneNumber, false) }}</p>
                      </div>
                    </template>
                    <template v-else-if="header.value == 'CRMWhatsappConversationFirstCRMAgentID' && navigation.tableVisibility[header.value]">
                      <template v-if="row.item.CRMWhatsappConversationFirstCRMAgentID && systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappConversationFirstCRMAgentID)">
                        <v-chip :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappConversationFirstCRMAgentID).CRMAgentColor || 'primary'" variant="flat" elevation="2" label>
                          <div style="display: flex; align-items: center;">
                            <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappConversationFirstCRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" :draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                            <p>{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappConversationFirstCRMAgentID).CRMAgentName || 'No registrado' }}</p>
                          </div>
                        </v-chip>
                      </template>
                      <template v-else>
                        <v-chip color="primary" variant="flat" elevation="2" label>
                          <div style="display: flex; align-items: center;">
                            <img :src="require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" :draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                            <p>No registrado</p>
                          </div>
                        </v-chip>
                      </template>
                    </template>
                    <template v-else-if="header.value == 'CRMWhatsappConversationStartDatetime' && navigation.tableVisibility[header.value]">
                      <p style="white-space: nowrap;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappConversationStartDatetime) }}</p>
                      <p style="font-size: x-small; color: #9e9e9e;">{{ row.item.CRMWhatsappConversationStartDatetimeOffsetToDisplay }}</p>
                    </template>
                    <template v-else-if="header.value == 'CRMWhatsappConversationCloseCRMAgentID' && navigation.tableVisibility[header.value]">
                      <template v-if="row.item.CRMWhatsappConversationCloseCRMAgentID && systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappConversationCloseCRMAgentID)">
                        <v-chip :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappConversationCloseCRMAgentID).CRMAgentColor || 'primary'" variant="flat" elevation="2" label>
                          <div style="display: flex; align-items: center;">
                            <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappConversationCloseCRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" :draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                            <p>{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappConversationCloseCRMAgentID).CRMAgentName || 'No registrado' }}</p>
                          </div>
                        </v-chip>
                      </template>
                      <template v-else>
                        <v-chip color="primary" variant="flat" elevation="2" label>
                          <div style="display: flex; align-items: center;">
                            <img :src="require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" :draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                            <p>No registrado</p>
                          </div>
                        </v-chip>
                      </template>
                    </template>
                    <template v-else-if="header.value == 'CRMWhatsappConversationEndDatetime' && navigation.tableVisibility[header.value]">
                      <p style="white-space: nowrap;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappConversationEndDatetime) }}</p>
                      <p style="font-size: x-small; color: #9e9e9e;">{{ row.item.CRMWhatsappConversationEndDatetimeOffsetToDisplay }}</p>
                    </template>
                    <template v-else-if="header.value == 'CRMWhatsappConversationDuration' && navigation.tableVisibility[header.value]">
                      <p style="white-space: nowrap;">{{ row.item.CRMWhatsappConversationEndDatetime == null || row.item.CRMWhatsappConversationStartDatetime == null ? ' No registrado' : $displayFunctions.default.fromMilisecondsToHHMMSS(new Date(row.item.CRMWhatsappConversationEndDatetime) - new Date(row.item.CRMWhatsappConversationStartDatetime)) }}</p>
                    </template>
                    <template v-else-if="header.value == 'CRMWhatsappConversationResult' && navigation.tableVisibility[header.value]">
                      <p style="white-space: nowrap;">{{ row.item.CRMWhatsappConversationResult || 'No registrado' }}</p>
                    </template>
                    <template v-else-if="header.value == 'CRMWhatsappConversationCRMWhatsappInvoiceAction' && navigation.tableVisibility[header.value]">
                      <template v-if="row.item.CRMWhatsappInvoices.length > 0">
                        <v-btn @click="$root.dialogComponent.openCRMWhatsappInvoiceDialog(row.item.CRMWhatsappInvoices)" color="primary" class="hoverableText">
                          <v-icon size="small" style="margin-right: 10px;">mdi-invoice-text</v-icon>
                          <p style="font-size: small;">{{ row.item.CRMWhatsappInvoices.length == 1 ? 'ORDEN' : 'ÓRDENES' }}</p>
                        </v-btn>
                      </template>
                    </template>
                    <template v-else-if="header.value == 'CRMWhatsappConversationAction' && navigation.tableVisibility[header.value]">
                      <v-btn 
                        @click="$root.dialogComponent.openCRMWhatsappConversationDialog(row.item.CRMWhatsappConversationID, true, false, false, true, true, true, false, false, false, false, false, false)" 
                        color="primary"
                        class="hoverableText"
                      >
                        <v-icon size="small" style="margin-right: 10px;">mdi-chat</v-icon>
                        <p style="font-size: small;">CONVERSACIÓN</p>
                      </v-btn>
                    </template>
                    <template v-else-if="header.value == 'CRMWhatsappConversationResumeAction' && navigation.tableVisibility[header.value]">
                      <v-btn 
                        @click="$root.dialogComponent.openResumeCRMWhatsappConversationDialog(row.item.CRMWhatsappConversationID)" 
                        color="primary"
                        class="hoverableText"
                      >
                        <v-icon size="small" style="margin-right: 10px;">mdi-chat-plus</v-icon>
                        <p style="font-size: small;">RETOMAR</p>
                      </v-btn>
                    </template>
                  </td>
                </template>
              </tr>
            </template>
            <template v-slot:bottom></template>
          </v-data-table>
        </template>
        <template v-else>
          <v-card color="primary" elevation="0" rounded="0" style="width: 100%; height: 55px"></v-card>
          <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
          <div style="flex: 1;">
            <template v-if="navigation.noData">
              <div 
                @click="setDefaultValues()"
                style="width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; padding: 15px;"
              >
                <div class="hoverableText">
                  <v-icon color="indigo" size="large" style="margin-bottom: 10px;">mdi-information</v-icon>
                  <p style="color: #9e9e9e;">No se encontraron conversaciones con los filtros seleccionados</p>
                  <p style="color: #9e9e9e;">Haz click <span style="color: #3F51B5; text-decoration: underline;">aquí</span> para limpiar los filtros de búsqueda</p>
                </div>
              </div>
            </template>
            <template v-else>
              <div style="width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; padding: 15px;">
                <v-icon color="indigo" size="large" style="margin-bottom: 10px;">mdi-information</v-icon>
                <div style="display: flex; align-items: center; gap: 10px;">
                  <p style="color: #9e9e9e;">Selecciona uno o más criterios de búsqueda y presiona</p>
                  <v-btn color="indigo" readonly>
                    <v-icon size="large" style="margin-right: 10px;">mdi-magnify</v-icon>
                    <h3>BUSCAR</h3>
                  </v-btn>
                </div>
              </div>
            </template>
          </div>
        </template>
      </template>
      <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
      <v-card elevation="0" rounded="0" color="primary" class="bottomContainer" style="padding: 10px; height: 60px; display: flex; justify-content: center; align-items: center;">
        <div v-if="display.CRMWhatsappConversation.length > 0" class="paginator">
          <v-pagination
            v-model="input.page"
            @update:model-value="display.CRMWhatsappConversation.length > 0 ? selectCRMWhatsappConversationFromCRMWhatsappConversationsView(false) : null"
            :length="Math.ceil(display.CRMWhatsappConversationCount / navigation.limit)"
            :total-visible="5"
            density="compact"
            size="small"
            :disabled="loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsViewPagination"
          ></v-pagination>
          <p style="font-size: x-small;">{{ (display.CRMWhatsappConversationCount == 0) ? `0 de 0 conversaciones` : `${(input.page - 1) * navigation.limit + 1} - ${Math.min(input.page * navigation.limit, display.CRMWhatsappConversationCount)} de ${display.CRMWhatsappConversationCount} ${display.CRMWhatsappConversationCount > 1 ? 'conversaciones' : 'conversación'}`}}</p>
        </div>
      </v-card>
    </div>
  </div>
</template>

<style scoped>
  .v-data-table th {
    padding: 0 !important;
  }

  .mainContainer {
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;
    overflow: hidden;
    margin-top: 0;
    padding-top: 0;
  }
  .navigationContainer {
    display: flex;
    flex-direction: column;
    width: 25%;
  }
  .navigationSearchContainer {
    flex: 1;
    width: 100%;
    padding: 15px;
    overflow-y: auto;
    scrollbar-width: thin;
  }
  .contentContainer {
    display: flex;
    flex-direction: column;
    height: 100%;
    flex: 1;
    overflow-y: auto;
    scrollbar-width: thin;
  }
  .paginator {
    margin-left: auto; 
    display: flex; 
    flex-direction: column; 
    justify-content: center; 
    align-items: center;
  }

  @media (max-width: 1200px) {
    .hideSearchContainer {
      display: none;
    }
    .mainContainer {
      flex-direction: column;
      height: auto;
      overflow-y: auto;
    }
    .navigationContainer {
      width: 100%;
    }
    .contentContainer {
      min-height: 900px;
      max-height: 900px;
    }
    .hideSummaryTable {
      min-height: 50px;
      max-height: 50px;
      align-items: center;
      justify-content: center;
    }
    .bottomContainer {
      min-height: 80px;
      max-height: 80px;
      align-items: center;
      justify-content: center;
    }
    .paginator {
      margin-left: 0;
      justify-content: center;
      align-items: center;
    }
  }
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  import { VDateInput } from 'vuetify/labs/VDateInput'
  import LZString from 'lz-string';
  import AppLoaderScreen from '@/components/AppLoaderScreen.vue';

  export default {
    inject: ['$generalFunctions', '$displayFunctions', '$assets'],
    components: 
    {
      VDateInput,
      AppLoaderScreen
    },
    data: () => 
    ({
      input: 
      {
        CRMWhatsappConversationID: null,
        CRMWhatsappContactID: null,
        CRMWhatsappContactSearch: null,
        CRMAgentID: [],
        CRMAgentIDSearch: null,
        allCRMAgentIDSelected: false,
        CRMWhatsappConversationStartDatetime: [new Date(), new Date()],
        CRMWhatsappConversationEndDatetime: [new Date(), new Date()],
        CRMWhatsappConversationResult: [],
        CRMWhatsappConversationResultSearch: null,
        allCRMWhatsappConversationResultSelected: false,
        CRMWhatsappConversationNoteContentOrCRMWhatsappMessageNoteContent: null,
        CRMWhatsappMessageContent: null,
        page: 1
      },
      display: 
      {
        CRMWhatsappContactOptions: [],
        CRMWhatsappConversationResultOptions: ['Venta', 'Venta perdida', 'Venta para otro día', 'Consulta de producto(s) sin venta', 'Nunca contestó', 'Dejó de contestar', 'Venta en localidad física', 'Consulta de información general sin venta', 'Solicitud de garantía', 'Reclamo', 'Sugerencia', 'Menor de edad', 'Vuelve a escribir', 'Seguimiento de contacto', 'Otro'],
        CRMWhatsappConversationHeaders:
        [
          {title: 'ID', value: 'CRMWhatsappConversationID', sortable: false, icon: 'mdi-barcode', index: 0},
          {title: 'CONTACTO', value: 'CRMWhatsappContactID', sortable: false, icon: 'mdi-account', index: 1},
          {title: 'INICIADA POR', value: 'CRMWhatsappConversationFirstCRMAgentID', sortable: false, icon: 'mdi-account-arrow-right', index: 2},
          {title: 'INICIADA EL', value: 'CRMWhatsappConversationStartDatetime', sortable: false, icon: 'mdi-calendar-start', index: 3},
          {title: 'FINALIZADA POR', value: 'CRMWhatsappConversationCloseCRMAgentID', sortable: false, icon: 'mdi-account-arrow-left', index: 4},
          {title: 'FINALIZADA EL', value: 'CRMWhatsappConversationEndDatetime', sortable: false, icon: 'mdi-calendar-end', index: 5},
          {title: 'DURACIÓN', value: 'CRMWhatsappConversationDuration', sortable: false, icon: 'mdi-clock', index: 6},
          {title: 'RESULTADO', value: 'CRMWhatsappConversationResult', sortable: false, icon: 'mdi-timeline', index: 7},
          {title: 'ORDEN', value: 'CRMWhatsappConversationCRMWhatsappInvoiceAction', sortable: false, icon: 'mdi-invoice-text', index: 8},
          {title: 'CONVERSACIÓN', value: 'CRMWhatsappConversationAction', sortable: false, icon: 'mdi-chat', index: 9},
          {title: 'RETOMAR', value: 'CRMWhatsappConversationResumeAction', sortable: false, icon: 'mdi-chat-plus', index: 10}
        ],
        CRMWhatsappConversationCount: 0,
        CRMWhatsappConversation: []
      },
      navigation: 
      {
        searchVisible: true,
        limit: 50,
        noData: false,
        CRMWhatsappConversationContextMenuIsVisible: false,
        CRMWhatsappConversationContextMenuItem: null,
        CRMWhatsappConversationContextMenuX: 0,
        CRMWhatsappConversationContextMenuY: 0,
        tableVisibility:
        {
          'CRMWhatsappConversationID': true,
          'CRMWhatsappContactID': true,
          'CRMWhatsappConversationFirstCRMAgentID': true,
          'CRMWhatsappConversationStartDatetime': true,
          'CRMWhatsappConversationCloseCRMAgentID': true,
          'CRMWhatsappConversationEndDatetime': true,
          'CRMWhatsappConversationDuration': true,
          'CRMWhatsappConversationResult': true,
          'CRMWhatsappConversationCRMWhatsappInvoiceAction': true,
          'CRMWhatsappConversationAction': true,
          'CRMWhatsappConversationResumeAction': true,
        }
      },
      loader: 
      {
        getSystemInformationData: false,
        autocompleteCRMWhatsappContact: false,
        selectCRMWhatsappConversationFromCRMWhatsappConversationsView: false,
        selectCRMWhatsappConversationFromCRMWhatsappConversationsViewPagination: false
      },
      interval: 
      {
        autocompleteCRMWhatsappContactInterval: null,
        tableScrollInterval: null,
        tickInterval: null
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgents: [],
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),

    methods:
    {
      async selectCRMWhatsappConversationFromCRMWhatsappConversationsView(newSearch){
        if (this.input.CRMWhatsappConversationStartDatetime.length == 0) this.input.CRMWhatsappConversationStartDatetime = [new Date(), new Date()];
        if (this.input.CRMWhatsappConversationEndDatetime.length == 0) this.input.CRMWhatsappConversationEndDatetime = [new Date(), new Date()];
        if (newSearch){
          this.input.page = 1;
          this.display.CRMWhatsappConversationCount = 0;
          this.display.CRMWhatsappConversation.length = 0;
          this.loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsView = true;
        }
        this.loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsViewPagination = true;
        const selectCRMWhatsappConversationFromCRMWhatsappConversationsViewRequestQuery =
        {
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'CRMWhatsappConversationID': this.input.CRMWhatsappConversationID,
          'CRMWhatsappContactID': this.input.CRMWhatsappContactID,
          'CRMAgentID': this.input.CRMAgentID,
          'CRMWhatsappConversationStartStartDatetime': this.input.CRMWhatsappConversationStartDatetime[0],
          'CRMWhatsappConversationStartEndDatetime': this.input.CRMWhatsappConversationStartDatetime[this.input.CRMWhatsappConversationStartDatetime.length - 1],
          'CRMWhatsappConversationEndStartDatetime': this.input.CRMWhatsappConversationEndDatetime[0],
          'CRMWhatsappConversationEndEndDatetime': this.input.CRMWhatsappConversationEndDatetime[this.input.CRMWhatsappConversationEndDatetime.length - 1],
          'CRMWhatsappConversationResult': this.input.CRMWhatsappConversationResult,
          'CRMWhatsappConversationNoteContentOrCRMWhatsappMessageNoteContent': this.input.CRMWhatsappConversationNoteContentOrCRMWhatsappMessageNoteContent,
          'CRMWhatsappMessageContent': this.input.CRMWhatsappMessageContent,
          'page': this.input.page,
          'limit': this.navigation.limit
        };
        const selectCRMWhatsappConversationFromCRMWhatsappConversationsViewResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappConversation/functions/selectCRMWhatsappConversationFromCRMWhatsappConversationsView', selectCRMWhatsappConversationFromCRMWhatsappConversationsViewRequestQuery);
        if (selectCRMWhatsappConversationFromCRMWhatsappConversationsViewResult.success){
          this.display.CRMWhatsappConversationCount = selectCRMWhatsappConversationFromCRMWhatsappConversationsViewResult.result.CRMWhatsappConversationCount;
          this.display.CRMWhatsappConversation = selectCRMWhatsappConversationFromCRMWhatsappConversationsViewResult.result.CRMWhatsappConversation;
          this.navigation.noData = this.display.CRMWhatsappConversationCount == 0;
          this.startTableScrollInterval();
          this.startTickInterval();
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappConversationFromCRMWhatsappConversationsView_error', 'error', 'Ha ocurrido un error inesperado al consultar la lista de conversaciones, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
        this.loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsView = false;
        this.loader.selectCRMWhatsappConversationFromCRMWhatsappConversationsViewPagination = false;
      },

      autocompleteCRMWhatsappContact(){
        if (this.interval.autocompleteCRMWhatsappContactInterval) {
          clearTimeout(this.interval.autocompleteCRMWhatsappContactInterval);
          this.interval.autocompleteCRMWhatsappContactInterval = null;
        }
        if (this.input.CRMWhatsappContactSearch && /\S/.test(this.input.CRMWhatsappContactSearch)){
          this.interval.autocompleteCRMWhatsappContactInterval = setTimeout(async () => {
            this.loader.autocompleteCRMWhatsappContact = true;
            if (!this.input.CRMWhatsappContactSearch) {
              this.display.CRMWhatsappContactOptions.length = 0;
              this.loader.autocompleteCRMWhatsappContact = false;
              this.$generalFunctions.default.blurInput(this, 'CRMWhatsappContactSearch');
              return;
            }
            const autocompleteCRMWhatsappContactRequestQuery =
            {
              'localStorage': 
              {
                'CRMAccountID': this.systemInformationData.CRMAccountID
              },
              'CRMWhatsappContactSearch': this.input.CRMWhatsappContactSearch
            };
            const autocompleteCRMWhatsappContactResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContact/functions/autocompleteCRMWhatsappContact', autocompleteCRMWhatsappContactRequestQuery);
            if (autocompleteCRMWhatsappContactResult.success) {
              this.display.CRMWhatsappContactOptions = autocompleteCRMWhatsappContactResult.result;
              if (this.display.CRMWhatsappContactOptions.length == 0) this.$root.notificationDialog.showSystemNotificationDialog('autocompleteCRMWhatsappContact_noResults', 'info', 'No se ha encontrado ningún contacto con el nombre buscado', null, false);
              else {
                this.display.CRMWhatsappContactOptions.forEach(CRMWhatsappContact => {
                  CRMWhatsappContact.CRMWhatsappContactAutocomplete = `${CRMWhatsappContact.CRMWhatsappContactName} - ${this.$displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(CRMWhatsappContact.CRMWhatsappContactPhoneNumber, false)}`;
                });
              }
            } else {
              this.$root.notificationDialog.showSystemNotificationDialog('autocompleteCRMWhatsappContact_error', 'error', 'Ha ocurrido un error inesperado al consultar los contactos, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
            }
            this.loader.autocompleteCRMWhatsappContact = false;          
          }, 1000);
        }
      },

      startTickInterval() {
        if (this.interval.tickInterval) clearInterval(this.interval.tickInterval);
        this.interval.tickInterval = null;
        const interval = () => {
          this.display.CRMWhatsappConversation.forEach(CRMWhatsappConversation => {
            CRMWhatsappConversation.CRMWhatsappConversationStartDatetimeOffsetToDisplay =
              this.$displayFunctions.default.getDatetimeOffsetToDayHHMMSS(
                CRMWhatsappConversation.CRMWhatsappConversationStartDatetime
              );
            CRMWhatsappConversation.CRMWhatsappConversationEndDatetimeOffsetToDisplay =
              this.$displayFunctions.default.getDatetimeOffsetToDayHHMMSS(
                CRMWhatsappConversation.CRMWhatsappConversationEndDatetime
              );
          });
        };
        interval();
        this.interval.tickInterval = setInterval(interval, 1000);
      },

      startTableScrollInterval(){
        if (this.interval.tableScrollInterval) clearInterval(this.interval.tableScrollInterval);
        this.interval.tableScrollInterval = null;
        let attempts = 0;
        this.interval.tableScrollInterval = setInterval(() => {
          const CRMWhatsappConversationTableWrapper = this.$refs.CRMWhatsappConversationTable?.$el;
          if (CRMWhatsappConversationTableWrapper){
            const CRMWhatsappConversationTable = CRMWhatsappConversationTableWrapper.querySelector('.v-table__wrapper');
            CRMWhatsappConversationTable.scrollTop = 0;
            CRMWhatsappConversationTable.scrollLeft = 0;
            clearInterval(this.interval.tableScrollInterval);
            this.interval.tableScrollInterval = null;
          }
          attempts = attempts + 1;
          if (attempts > 10){
            clearInterval(this.interval.tableScrollInterval);
            this.interval.tableScrollInterval = null;
          }
        }, 10);
      },

      copyCRMWhatsappConversationToClipboard(){
        let copyCRMWhatsappConversationToClipboard =
        [
          `CONVERSACIÓN ${this.navigation.CRMWhatsappConversationContextMenuItem.CRMWhatsappConversationID}\n\n`,
          this.navigation.tableVisibility.CRMWhatsappContactID ? `ID del contacto: ${this.navigation.CRMWhatsappConversationContextMenuItem.CRMWhatsappContactID}\n` : '',
          this.navigation.tableVisibility.CRMWhatsappContactID ? `Nombre del contacto: ${this.$displayFunctions.default.parseCRMWhatsappContactNameToDisplay(this.navigation.CRMWhatsappConversationContextMenuItem)}\n` : '',
          this.navigation.tableVisibility.CRMWhatsappContactID ? `Teléfono del contacto: ${this.$displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(this.navigation.CRMWhatsappConversationContextMenuItem.CRMWhatsappConversationPhoneNumber, false)}\n` : '',
          this.navigation.tableVisibility.CRMWhatsappConversationFirstCRMAgentID ? `Agente que inició la conversación: ${this.systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == this.navigation.CRMWhatsappConversationContextMenuItem.CRMWhatsappConversationFirstCRMAgentID) ? this.systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == this.navigation.CRMWhatsappConversationContextMenuItem.CRMWhatsappConversationFirstCRMAgentID).CRMAgentName : 'No registrado'}\n` : '',
          this.navigation.tableVisibility.CRMWhatsappConversationStartDatetime ? `Fecha de inicio de la conversación: ${this.$displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(this.navigation.CRMWhatsappConversationContextMenuItem.CRMWhatsappConversationStartDatetime)}\n` : '',
          this.navigation.tableVisibility.CRMWhatsappConversationCloseCRMAgentID ? `Agente que finalizó la conversación: ${this.systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == this.navigation.CRMWhatsappConversationContextMenuItem.CRMWhatsappConversationCloseCRMAgentID) ? this.systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == this.navigation.CRMWhatsappConversationContextMenuItem.CRMWhatsappConversationCloseCRMAgentID).CRMAgentName : 'No registrado'}\n` : '',
          this.navigation.tableVisibility.CRMWhatsappConversationEndDatetime ? `Fecha de fin de la conversación: ${this.$displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(this.navigation.CRMWhatsappConversationContextMenuItem.CRMWhatsappConversationEndDatetime)}\n` : '',
          this.navigation.tableVisibility.CRMWhatsappConversationDuration ? `Duración de la conversación: ${this.$displayFunctions.default.fromMilisecondsToHHMMSS(new Date(this.navigation.CRMWhatsappConversationContextMenuItem.CRMWhatsappConversationEndDatetime) - new Date(this.navigation.CRMWhatsappConversationContextMenuItem.CRMWhatsappConversationStartDatetime))}\n` : '',
          this.navigation.tableVisibility.CRMWhatsappConversationResult ? `Resultado de la conversación: ${this.navigation.CRMWhatsappConversationContextMenuItem.CRMWhatsappConversationResult}\n` : '',
        ].join('');
        this.$generalFunctions.default.copyToClipboardWithoutTitle(this, 'Resumen de la conversación', 'a', copyCRMWhatsappConversationToClipboard);
      },

      updateURLSearchQuery(){
        if (this.input.CRMWhatsappConversationStartDatetime.length == 0) this.input.CRMWhatsappConversationStartDatetime = [new Date(), new Date()];
        if (this.input.CRMWhatsappConversationEndDatetime.length == 0) this.input.CRMWhatsappConversationEndDatetime = [new Date(), new Date()];
        let searchQuery = 
        {
          '1': this.input.CRMWhatsappConversationID,
          '2': this.input.CRMWhatsappContactID,
          '3': this.input.CRMWhatsappContactID && this.display.CRMWhatsappContactOptions.find(CRMWhatsappContact => CRMWhatsappContact.CRMWhatsappContactID == this.input.CRMWhatsappContactID) ? [this.display.CRMWhatsappContactOptions.find(CRMWhatsappContact => CRMWhatsappContact.CRMWhatsappContactID == this.input.CRMWhatsappContactID).CRMWhatsappContactName, this.display.CRMWhatsappContactOptions.find(CRMWhatsappContact => CRMWhatsappContact.CRMWhatsappContactID == this.input.CRMWhatsappContactID).CRMWhatsappContactPhoneNumber, this.display.CRMWhatsappContactOptions.find(CRMWhatsappContact => CRMWhatsappContact.CRMWhatsappContactID == this.input.CRMWhatsappContactID).CRMWhatsappContactAutocomplete] : null,
          
          '4': this.input.CRMAgentID,
          '5': this.input.CRMWhatsappConversationStartDatetime[0],
          '6': this.input.CRMWhatsappConversationStartDatetime[this.input.CRMWhatsappConversationStartDatetime.length - 1],
          '7': this.input.CRMWhatsappConversationEndDatetime[0],
          '8': this.input.CRMWhatsappConversationEndDatetime[this.input.CRMWhatsappConversationEndDatetime.length - 1],
          '9': this.input.CRMWhatsappConversationResult,
          '10': this.input.CRMWhatsappConversationNoteContentOrCRMWhatsappMessageNoteContent,
          '11': this.input.CRMWhatsappMessageContent
        };
        searchQuery = Object.fromEntries(Object.entries(searchQuery).filter(([ , v]) => v != null && v != undefined));
        const searchQueryCompressed = LZString.compressToEncodedURIComponent(JSON.stringify(searchQuery));
        this.$router.replace({query: {searchQuery: searchQueryCompressed}});
      },

      async decodeURLSearchQuery(){
        let searchQuery = this.$route.query.searchQuery;
        if (searchQuery){
          searchQuery = JSON.parse(LZString.decompressFromEncodedURIComponent(searchQuery));
          this.input.CRMWhatsappConversationID = searchQuery['1'];
          this.input.CRMWhatsappContactID = searchQuery['2'];
          this.display.CRMWhatsappContactOptions = searchQuery['2'] && searchQuery['3'] ? [{'CRMWhatsappContactID': searchQuery['2'], 'CRMWhatsappContactName': searchQuery['3'][0], 'CRMWhatsappContactPhoneNumber': searchQuery['3'][1], 'CRMWhatsappContactAutocomplete': searchQuery['3'][2]}] : [];
          this.input.CRMAgentID = searchQuery['4'];
          this.input.allCRMAgentIDSelected = searchQuery['4'].length == this.systemInformationData.CRMAgents.filter(CRMAgent => CRMAgent.CRMAgentID != null).length;
          if (searchQuery['5'] && !isNaN(new Date(searchQuery['5']).getTime()) && searchQuery['6'] && !isNaN(new Date(searchQuery['6']).getTime())) this.input.CRMWhatsappConversationStartDatetime = (() => { const s = new Date(searchQuery['5']); const e = new Date(searchQuery['6']); s.setHours(0,0,0,0); e.setHours(0,0,0,0); const d = Math.floor((e - s) / 86400000) + 1; return Array.from({length: d}, (_, i) => new Date(s.getTime() + i * 86400000)); })();
          else this.input.CRMWhatsappConversationStartDatetime = [new Date(), new Date()];
          if (searchQuery['7'] && !isNaN(new Date(searchQuery['7']).getTime()) && searchQuery['8'] && !isNaN(new Date(searchQuery['8']).getTime())) this.input.CRMWhatsappConversationEndDatetime = (() => { const s = new Date(searchQuery['7']); const e = new Date(searchQuery['8']); s.setHours(0,0,0,0); e.setHours(0,0,0,0); const d = Math.floor((e - s) / 86400000) + 1; return Array.from({length: d}, (_, i) => new Date(s.getTime() + i * 86400000)); })();
          else this.input.CRMWhatsappConversationEndDatetime = [new Date(), new Date()];
          this.input.CRMWhatsappConversationResult = searchQuery['9'] || [];
          this.input.allCRMWhatsappConversationResultSelected = searchQuery['9'].length == this.display.CRMWhatsappConversationResultOptions.length;
          this.input.CRMWhatsappConversationNoteContentOrCRMWhatsappMessageNoteContent = searchQuery['10'];
          this.input.CRMWhatsappMessageContent = searchQuery['11'];
        }
      },

      updateTableVisibility(){
        localStorage.setItem('CRMWhatsappConversationsView_CRMWhatsappConversationHeadersVisibility', JSON.stringify(this.navigation.tableVisibility));      
      },

      updateTableHeaderIndex(headerKey, indexChange) {
        const updatedTableHeader = this.display.CRMWhatsappConversationHeaders.find(header => header.value == headerKey);
        const swappedTableHeader = this.display.CRMWhatsappConversationHeaders.find(header => header.index == (this.display.CRMWhatsappConversationHeaders.find(header => header.value == headerKey).index + indexChange));
        if (updatedTableHeader && swappedTableHeader) [updatedTableHeader.index, swappedTableHeader.index] = [swappedTableHeader.index, updatedTableHeader.index];
        const headers = this.display.CRMWhatsappConversationHeaders.reduce((headers, header) => {headers[header.value] = header.index; return headers;}, {});
        localStorage.setItem('CRMWhatsappConversationsView_CRMWhatsappConversationHeadersIndex', JSON.stringify(headers));      
      },

      async prepareTable() {
        let headersVisibility;
        try { headersVisibility = JSON.parse(localStorage.getItem('CRMWhatsappConversationsView_CRMWhatsappConversationHeadersVisibility')); }
        catch { headersVisibility = null; }
        for (const headerKey in headersVisibility){
          if (this.navigation.tableVisibility[headerKey]) this.navigation.tableVisibility[headerKey] = headersVisibility[headerKey];
        }
        let headersIndex;
        try { headersIndex = JSON.parse(localStorage.getItem('CRMWhatsappConversationsView_CRMWhatsappConversationHeadersIndex')); }
        catch { headersIndex = null; }
        this.display.CRMWhatsappConversationHeaders = this.display.CRMWhatsappConversationHeaders.map(header => ({ ...header, index: headersIndex?.[header.value] ?? Infinity })).sort((headerA, headerB) => headerA.index - headerB.index).map((header, i) => ({ ...header, index: i }));
        this.loader.getSystemInformationData = false;
      },

      setDefaultValues(){
        this.input.CRMWhatsappConversationID = null;
        this.input.CRMWhatsappContactID = null;
        this.input.CRMWhatsappContactSearch = null;
        this.input.CRMAgentID.length = 0;
        this.input.CRMAgentIDSearch = null;
        this.input.allCRMAgentIDSelected = false;
        this.input.CRMWhatsappConversationStartDatetime = [new Date(), new Date()];
        this.input.CRMWhatsappConversationEndDatetime = [new Date(), new Date()];
        this.input.CRMWhatsappConversationResult.length = 0;
        this.input.CRMWhatsappConversationResultSearch = null;
        this.input.allCRMWhatsappConversationResultSelected = false;
        this.input.CRMWhatsappConversationStartDatetime.length = 0;
        this.input.CRMWhatsappConversationEndDatetime.length = 0;
        this.input.CRMWhatsappConversationNoteContentOrCRMWhatsappMessageNoteContent = null;
        this.input.CRMWhatsappMessageContent = null;
        this.display.CRMWhatsappConversationCount = 0;
        this.display.CRMWhatsappConversation.length = 0;
        this.navigation.noData = false;
        this.$generalFunctions.default.focusInput(this, 'CRMWhatsappConversationID');
        this.updateURLSearchQuery();
      },

      async getSystemInformation(){
        this.loader.getSystemInformationData = true;
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.CRMAgents = systemInformation.getCRMAgents;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      }
    },

    async mounted(){
      await this.getSystemInformation();
      await this.prepareTable();
      await this.decodeURLSearchQuery();
      this.$generalFunctions.default.focusInput(this, 'CRMWhatsappConversationID');
    },

    beforeUnmount(){
      if (this.interval.tableScrollInterval) clearInterval(this.interval.tableScrollInterval);
      this.interval.tableScrollInterval = null;
      if (this.interval.tickInterval) clearInterval(this.interval.tickInterval);
      this.interval.tickInterval = null;
      if (this.systemInformationData.updateSubscription) systemInformation.unsubscribeFromUpdate(this.systemInformationData.updateSubscription);
      this.systemInformationData.updateSubscription = null;
    }
  }
</script>